import { render, staticRenderFns } from "./UpdateCustomer.vue?vue&type=template&id=00806f4f&scoped=true"
import script from "./UpdateCustomer.vue?vue&type=script&lang=js"
export * from "./UpdateCustomer.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomer.vue?vue&type=style&index=0&id=00806f4f&prod&scoped=true&lang=css"
import style1 from "./UpdateCustomer.vue?vue&type=style&index=1&id=00806f4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00806f4f",
  null
  
)

export default component.exports